import { Dialog } from 'components/dialogs/Dialog'
import { DialogCloseButton } from 'components/dialogs/DialogCloseButton'
import { MeetingPreviewLoader } from 'pages/meeting/MeetingPreview'
import { useTranslationTyped } from 'i18n/i18n'

export function ShowExperienceDialog({
  slideDeckId,
  sectionId,
  assignmentId,
}: {
  slideDeckId: string
  /** Students must provide sectionId + assignmentId for API auth */
  sectionId?: string
  assignmentId?: string
}) {
  const { tt } = useTranslationTyped()
  return (
    <Dialog
      size="custom"
      className="relative flex h-[95vh] w-[95vw] flex-col justify-start overflow-hidden rounded-3xl bg-core-secondary"
      aria-labelledby={undefined}
      aria-label={tt.student_assignment.view_experience()}
    >
      <DialogCloseButton className="z-[100]" />
      <div className="h-full p-6">
        <div className="relative h-full">
          <MeetingPreviewLoader
            slideDeckId={slideDeckId}
            sectionId={sectionId}
            assignmentId={assignmentId}
          />
        </div>
      </div>
    </Dialog>
  )
}
